var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "container-s" },
    [
      _c(
        "div",
        { attrs: { id: "terms-title" } },
        [
          _c("page-title", {
            staticStyle: { margin: "16px 0 24px 0" },
            attrs: { title: "Nutzungsbestimmungen" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticClass: "btn-layout",
          attrs: { wrap: "", "align-center": "", "justify-center": "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "", md12: "", lg10: "" } }, [
            _c("div", { staticClass: "terms-of-use-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "terms-of-use-text",
                  staticStyle: { "text-align": "justify", "font-size": "1em" }
                },
                [
                  !_vm.termsOfUse.singlePage
                    ? _c(
                        "div",
                        [
                          _c("viewer", { attrs: { data: _vm.termsOfUse.text } })
                        ],
                        1
                      )
                    : _c("div", [
                        _c(
                          "div",
                          { staticStyle: { "margin-bottom": "24px" } },
                          [
                            _c("p", [_vm._v("Sehr geehrter Anwender")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                leider verfügen Sie über keinen gültigen Softwarepflegevertrag\n                mit uns. Daher können Sie keine Support-Anfrage stellen.\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                Falls Sie einen Softwarepflegevertrag abschließen möchten,\n                wenden Sie sich bitte an unseren Vertrieb unter\n                "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:vertrieb@werbas-ksr.com"
                                  }
                                },
                                [_vm._v("vertrieb@werbas-ksr.com")]
                              ),
                              _vm._v(
                                "\n                oder +49 731 20555-165\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v("Ihre Werbas KSR GmbH")])
                          ]
                        )
                      ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          !_vm.termsOfUse.singlePage
            ? _c(
                "v-layout",
                {
                  staticStyle: { "text-align": "right", width: "100%" },
                  attrs: {
                    wrap: "",
                    flex: "",
                    "align-center": "",
                    "justify-center": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md6: "", lg5: "" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "custom-label-color",
                        attrs: {
                          label:
                            "Ja, ich bin mit den obigen Bestimmungen einverstanden."
                        },
                        model: {
                          value: _vm.disabled,
                          callback: function($$v) {
                            _vm.disabled = $$v
                          },
                          expression: "disabled"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        id: "buttons-container",
                        xs12: "",
                        sm6: "",
                        md6: "",
                        lg5: ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { id: "form-button" },
                          on: {
                            click: function($event) {
                              return _vm.toBack()
                            }
                          }
                        },
                        [_vm._v("Zurück")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { id: "form-button", disabled: !_vm.disabled },
                          on: {
                            click: function($event) {
                              return _vm.newSupportRequest()
                            }
                          }
                        },
                        [_vm._v("Weiter")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-flex",
                {
                  staticStyle: { "text-align": "end" },
                  attrs: { xs12: "", md12: "", lg10: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { id: "form-button" },
                      on: {
                        click: function($event) {
                          return _vm.toBack()
                        }
                      }
                    },
                    [_vm._v("Zurück")]
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }